import React, { useContext } from 'react'
import DashboardNoDataInfo from '@Scenes/RightsholderScene/RightsholderDashboard/DashboardNoDataInfo'
import Button from '@Components/Buttons/Button'
import Navigation from '@App/navigation'
import { StoresContext } from '@App/contexts'
import './index.scss'
import DashboardKpiCard from '@Scenes/RightsholderScene/RightsholderDashboard/DashboardKpiCard'

interface DashboardWorksKpiCardProps {
    data: number
    change?: number
}

const DashboardWorksKpiCard = ({ data, change }: DashboardWorksKpiCardProps) => {
    const { rightsholderStore } = useContext(StoresContext)
    return (
        <DashboardKpiCard
            title="Your registered works"
            data={data.toLocaleString('en-US')}
            className="total-works"
            noDataInfo={!data ? <DashboardNoDataInfo type="works" finalWord="submitted" /> : undefined}
        >
            {!data && (
                <div className="button-container">
                    <Button
                        mainColor
                        type="primary-small"
                        typeLink
                        linkTo={Navigation.rightholder.createWork.root(rightsholderStore.currentRightsholderId)}
                    >
                        Register Works
                    </Button>
                </div>
            )}
        </DashboardKpiCard>
    )
}

export default DashboardWorksKpiCard
